import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=84a97a0c&scoped=true&"
import script from "./ErrorMessage.vue?vue&type=script&lang=ts&"
export * from "./ErrorMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a97a0c",
  null
  
)

export default component.exports